import { useContext } from "react";
import { ServiceContext } from "../../Contexts/ServiceContext/ServiceContext";
import { GLOBALS } from "../../Models/Globals";
import { CardDocumentRender } from "../CardDocumentRender/CardDocumentRender";
import { SecFillingsRender } from "../SecFillingsRender/SecFillingsRender";
import { VerticalDocumentRender } from "../VerticalDocumentRender/VerticalDocumentRender";
import { ZoneDocumentRender } from "../ZoneDocumentRender/ZoneDocumentRender";



export const MainContainer = () => {

    const { SrvContext } = useContext(ServiceContext);

    const {
        WindowData
    } = SrvContext;


    return (

        <>
            {
                WindowData.sccoDocsRender.RenderType == GLOBALS.RENDER_CARD &&
                <CardDocumentRender />
            }
            {
                WindowData.sccoDocsRender.RenderType == GLOBALS.RENDER_VERTICAL &&
                <VerticalDocumentRender />
            }
            {
                WindowData.sccoDocsRender.RenderType == GLOBALS.RENDER_SEC_FILLINGS &&
                <SecFillingsRender />
            }
            {
                WindowData.sccoDocsRender.RenderType == GLOBALS.RENDER_ZONA_DOCS &&
                <ZoneDocumentRender />
            }
        </>


    );

};